import axios from "axios";

import { baseApiUrl } from "../General/Constants";

import localStorageProvider from '../Providers/LocalStorageProvider';

export const updateAll = (categories: any) => {
  const url = `${baseApiUrl}/customer/private/category/updateAll`;
  const token = localStorageProvider.getItem("token");
  const auth = { headers: { Authorization: `Bearer ${token}` } };

  return axios.post(url, categories, auth).then(({ data }) => ({ data }));
};
